import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconSalesRepresentatives from 'components/icons/IconSalesRepresentatives';

const styles = () => ({
  root: {
    height: 330,
  },
  iconSalesRepresentatives: {
    width: 86,
    height: 104,
  },
});

const EraActionsTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconSalesRepresentatives className={classes.iconSalesRepresentatives} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such claim adjustment codes
      </Typography>
    </Grid>
  </Grid>
);

EraActionsTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconSalesRepresentatives: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(EraActionsTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/EraActionsTable/EraActionsTableEmpty.js